module.exports = __webpack_public_path__ + "static/covidicon-d1c53131d23f14df1f3b374cf0be815a.svg";